import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgFocusDirective } from './ag-focus.directive';
import { AgFieldTitleDirective } from './ag-field-title.directive';
import { AgRequiredDirective } from './ag-required.directive';

@NgModule({
  declarations: [AgFocusDirective, AgFieldTitleDirective, AgRequiredDirective],
  imports: [CommonModule],
  exports: [AgFocusDirective, AgFieldTitleDirective, AgRequiredDirective],
})
export class AgFieldsModule {}
